import Add from "./Add";
import Add2 from "./Add2";
import Add3 from "./Add3";
import Advance from "./Advance";
import Advisor from "./Advisor";
import AdvisorOutlined from "./AdvisorOutlined";
import Antyposlizgowa60 from "./Antyposlizgowa60";
import ArchitectZone from "./ArchitectZone";
import ArchitectsZone from "./ArchitectsZone";
import ArrowBack from "./ArrowBack";
import ArrowBackBold from "./ArrowBackBold";
import ArrowBackSmall from "./ArrowBackSmall";
import ArrowDown from "./ArrowDown";
import ArrowForward from "./ArrowForward";
import ArrowRight from "./ArrowRight";
import ArrowTopLong from "./ArrowTopLong";
import ArrowUp from "./ArrowUp";
import Assembly from "./Assembly";
import AssemblyNarrow from "./AssemblyNarrow";
import Assignment from "./Assignment";
import Bag from "./Bag";
import Bezprzylgowe60 from "./Bezprzylgowe60";
import BigArrowRight from "./BigArrowRight";
import BigChevronLeft from "./BigChevronLeft";
import BigChevronRight from "./BigChevronRight";
import Blank from "./Blank";
import Bringing from "./Bringing";
import BringingOff from "./BringingOff";
import Call from "./Call";
import Card from "./Card";
import Catalogue6015 from "./Catalogue6015";
import Chat from "./Chat";
import Chat2 from "./Chat2";
import Check from "./Check";
import Check2 from "./Check2";
import CheckCircle from "./CheckCircle";
import CheckCircleOutline from "./CheckCircleOutline";
import Checklist6015 from "./Checklist6015";
import ChevronLeft from "./ChevronLeft";
import ChevronRight from "./ChevronRight";
import CichaPodloga60 from "./CichaPodloga60";
import Clean from "./Clean";
import Close from "./Close";
import Close2 from "./Close2";
import Close3 from "./Close3";
import CoffeOutline from "./CoffeOutline";
import Coffee from "./Coffee";
import Coffee6015 from "./Coffee6015";
import Copy from "./Copy";
import Create from "./Create";
import Creative from "./Creative";
import Cubic from "./Cubic";
import CubicMonitor from "./CubicMonitor";
import Customize from "./Customize";
import CustomizeRounded from "./CustomizeRounded";
import Date from "./Date";
import Delivery6010 from "./Delivery6010";
import Delivery6015 from "./Delivery6015";
import DeliveryOutline from "./DeliveryOutline";
import DesignInVoxboxVr from "./DesignInVoxboxVr";
import Divide from "./Divide";
import Door from "./Door";
import Door6010 from "./Door6010";
import Doors from "./Doors";
import Download from "./Download";
import Download2 from "./Download2";
import DragHandle from "./DragHandle";
import EcCart from "./EcCart";
import EcCart2 from "./EcCart2";
import Eclipse from "./Eclipse";
import Egger from "./Egger";
import Email from "./Email";
import EmptyPicture from "./EmptyPicture";
import Error from "./Error";
import ErrorOutline from "./ErrorOutline";
import ExpandLess from "./ExpandLess";
import ExpandMore from "./ExpandMore";
import ExpandMoreOutline from "./ExpandMoreOutline";
import Facebook from "./Facebook";
import Farba60 from "./Farba60";
import Filter from "./Filter";
import FilterList from "./FilterList";
import FilterUnselected from "./FilterUnselected";
import Filters from "./Filters";
import Floor from "./Floor";
import FreeInteriorDesign from "./FreeInteriorDesign";
import Friendly from "./Friendly";
import FullInterior from "./FullInterior";
import Furniture from "./Furniture";
import GlebokaStruktura60 from "./GlebokaStruktura60";
import Grid from "./Grid";
import GridSelected from "./GridSelected";
import GridSelected2 from "./GridSelected2";
import GroupMonitor from "./GroupMonitor";
import GruboscBezPodkladu5Mm60 from "./GruboscBezPodkladu5Mm60";
import GruboscZpodkladem515Mm60 from "./GruboscZpodkladem515Mm60";
import Guarantee10Years from "./Guarantee10Years";
import Guarantee2Years from "./Guarantee2Years";
import Help from "./Help";
import HelpOutline from "./HelpOutline";
import Hettich from "./Hettich";
import InPost from "./InPost";
import Info from "./Info";
import InfoOutline from "./InfoOutline";
import InsertDriveFile from "./InsertDriveFile";
import InsertDriveFilePlus from "./InsertDriveFilePlus";
import InsertPhoto from "./InsertPhoto";
import Instagram from "./Instagram";
import Interiors from "./Interiors";
import IzolacjaAkustyczna60 from "./IzolacjaAkustyczna60";
import KlasaUzytkowa60 from "./KlasaUzytkowa60";
import KomfortChodzenia60 from "./KomfortChodzenia60";
import KonstrukcjaPlytowa60 from "./KonstrukcjaPlytowa60";
import KonstrukcjaRamiakowa60 from "./KonstrukcjaRamiakowa60";
import KontaktZzywnoscia60 from "./KontaktZzywnoscia60";
import Kronospan from "./Kronospan";
import Language from "./Language";
import LatweUtrzymanieCzystosci60 from "./LatweUtrzymanieCzystosci60";
import LatwyMontaz60 from "./LatwyMontaz60";
import Lekkosc60 from "./Lekkosc60";
import Link from "./Link";
import Linkedin from "./Linkedin";
import List from "./List";
import ListSelected from "./ListSelected";
import LocationSearching from "./LocationSearching";
import Logged from "./Logged";
import Login from "./Login";
import Login1 from "./Login1";
import LoginOutline from "./LoginOutline";
import Logo from "./Logo";
import LogoVoxBlack from "./LogoVoxBlack";
import Loudspeaker from "./Loudspeaker";
import Mail6015 from "./Mail6015";
import Maps from "./Maps";
import MaterialLibrary from "./MaterialLibrary";
import MatowaPowierzchnia60 from "./MatowaPowierzchnia60";
import Meet6010 from "./Meet6010";
import Meet6015 from "./Meet6015";
import MeetOutline from "./MeetOutline";
import Menu from "./Menu";
import Minus from "./Minus";
import Minus2 from "./Minus2";
import Minus3 from "./Minus3";
import Money from "./Money";
import MoneyNarrow from "./MoneyNarrow";
import MontazNaKlej60 from "./MontazNaKlej60";
import MontazPionPoziom60 from "./MontazPionPoziom60";
import MontazScianaSufit60 from "./MontazScianaSufit60";
import MoreHoriz from "./MoreHoriz";
import MoreVert from "./MoreVert";
import NaNierownePodloza60 from "./NaNierownePodloza60";
import Navigation from "./Navigation";
import NavigationBack from "./NavigationBack";
import NieWymagaKonserwacji60 from "./NieWymagaKonserwacji60";
import NoAssembly from "./NoAssembly";
import OdpornaNaUderzenia60 from "./OdpornaNaUderzenia60";
import OdpornaNaZmianyTemperatury60 from "./OdpornaNaZmianyTemperatury60";
import OdpornoscNaUderzenia60 from "./OdpornoscNaUderzenia60";
import OdpornoscNaZadrapania60 from "./OdpornoscNaZadrapania60";
import OdpornoscUv60 from "./OdpornoscUv60";
import OgrzewaniePodlogowe60 from "./OgrzewaniePodlogowe60";
import Okleina60 from "./Okleina60";
import OrderArrowList from "./OrderArrowList";
import Paragon from "./Paragon";
import PaymentLink from "./PaymentLink";
import Percent from "./Percent";
import PhoneCheck from "./PhoneCheck";
import Pinterest from "./Pinterest";
import PioroWpust60 from "./PioroWpust60";
import Place1 from "./Place1";
import Place2 from "./Place2";
import Place6015 from "./Place6015";
import PlaceOutline from "./PlaceOutline";
import PlaceOutline2 from "./PlaceOutline2";
import Plamoodporna60 from "./Plamoodporna60";
import PlasterMiodu60 from "./PlasterMiodu60";
import PlytaOtworowana60 from "./PlytaOtworowana60";
import PlytaPelna60 from "./PlytaPelna60";
import Poland6010 from "./Poland6010";
import PolandOutlined from "./PolandOutlined";
import Print from "./Print";
import Przylgowe60 from "./Przylgowe60";
import Recykling60 from "./Recykling60";
import ReportGmailerrorred from "./ReportGmailerrorred";
import Resize from "./Resize";
import Revers60 from "./Revers60";
import Rotate from "./Rotate";
import RysunekDrewna60 from "./RysunekDrewna60";
import Safe from "./Safe";
import Search from "./Search";
import Send from "./Send";
import Send2 from "./Send2";
import Settings from "./Settings";
import Shield from "./Shield";
import Shit from "./Shit";
import ShoppingCart from "./ShoppingCart";
import SoppingCart0 from "./SoppingCart0";
import SpeakerOff from "./SpeakerOff";
import SpeakerOn from "./SpeakerOn";
import Spinner from "./Spinner";
import Star from "./Star";
import StrongClick60 from "./StrongClick60";
import StrukturaKamien60 from "./StrukturaKamien60";
import SubtelneLaczenie60 from "./SubtelneLaczenie60";
import Succes from "./Succes";
import Surface from "./Surface";
import SwapVert from "./SwapVert";
import SystemClick60 from "./SystemClick60";
import Szyba60 from "./Szyba60";
import SzybkiMontaz60 from "./SzybkiMontaz60";
import Testmagda from "./Testmagda";
import Trash from "./Trash";
import Truck from "./Truck";
import TruckNarrow from "./TruckNarrow";
import UkrytaOscieznica60 from "./UkrytaOscieznica60";
import UkrytaWentylacja60 from "./UkrytaWentylacja60";
import Upload from "./Upload";
import Users from "./Users";
import Verified from "./Verified";
import Vfuga60 from "./Vfuga60";
import Visibility from "./Visibility";
import VisibilityOff from "./VisibilityOff";
import VoxGate from "./VoxGate";
import Voxbox from "./Voxbox";
import Voxbox6010 from "./Voxbox6010";
import Voxbox6015 from "./Voxbox6015";
import VoxboxMonitor from "./VoxboxMonitor";
import VoxboxNarrow from "./VoxboxNarrow";
import VoxboxOutline from "./VoxboxOutline";
import WalkingComfort from "./WalkingComfort";
import WalkingComfortRounded from "./WalkingComfortRounded";
import Walls from "./Walls";
import Warning from "./Warning";
import WarningAmber from "./WarningAmber";
import WatchLater from "./WatchLater";
import WatchOutlined from "./WatchOutlined";
import WentylacjaFasady60 from "./WentylacjaFasady60";
import Whatsapp from "./Whatsapp";
import Wodoodporna60 from "./Wodoodporna60";
import Wodoodpornosc60 from "./Wodoodpornosc60";
import Youtube from "./Youtube";
import ZintegrowanyPodklad60 from "./ZintegrowanyPodklad60";
import FullInteriorXl from "./FullInteriorXl";
import Guarantee from "./Guarantee";
import Offer from "./Offer";
import StainResistant from "./StainResistant";
import Waterproof from "./Waterproof";
export const iconComponentsMap = {
  Add: Add,
  Add2: Add2,
  Add3: Add3,
  Advance: Advance,
  Advisor: Advisor,
  AdvisorOutlined: AdvisorOutlined,
  Antyposlizgowa60: Antyposlizgowa60,
  ArchitectZone: ArchitectZone,
  ArchitectsZone: ArchitectsZone,
  ArrowBack: ArrowBack,
  ArrowBackBold: ArrowBackBold,
  ArrowBackSmall: ArrowBackSmall,
  ArrowDown: ArrowDown,
  ArrowForward: ArrowForward,
  ArrowRight: ArrowRight,
  ArrowTopLong: ArrowTopLong,
  ArrowUp: ArrowUp,
  Assembly: Assembly,
  AssemblyNarrow: AssemblyNarrow,
  Assignment: Assignment,
  Bag: Bag,
  Bezprzylgowe60: Bezprzylgowe60,
  BigArrowRight: BigArrowRight,
  BigChevronLeft: BigChevronLeft,
  BigChevronRight: BigChevronRight,
  Blank: Blank,
  Bringing: Bringing,
  BringingOff: BringingOff,
  Call: Call,
  Card: Card,
  Catalogue6015: Catalogue6015,
  Chat: Chat,
  Chat2: Chat2,
  Check: Check,
  Check2: Check2,
  CheckCircle: CheckCircle,
  CheckCircleOutline: CheckCircleOutline,
  Checklist6015: Checklist6015,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  CichaPodloga60: CichaPodloga60,
  Clean: Clean,
  Close: Close,
  Close2: Close2,
  Close3: Close3,
  CoffeOutline: CoffeOutline,
  Coffee: Coffee,
  Coffee6015: Coffee6015,
  Copy: Copy,
  Create: Create,
  Creative: Creative,
  Cubic: Cubic,
  CubicMonitor: CubicMonitor,
  Customize: Customize,
  CustomizeRounded: CustomizeRounded,
  Date: Date,
  Delivery6010: Delivery6010,
  Delivery6015: Delivery6015,
  DeliveryOutline: DeliveryOutline,
  DesignInVoxboxVr: DesignInVoxboxVr,
  Divide: Divide,
  Door: Door,
  Door6010: Door6010,
  Doors: Doors,
  Download: Download,
  Download2: Download2,
  DragHandle: DragHandle,
  EcCart: EcCart,
  EcCart2: EcCart2,
  Eclipse: Eclipse,
  Egger: Egger,
  Email: Email,
  EmptyPicture: EmptyPicture,
  Error: Error,
  ErrorOutline: ErrorOutline,
  ExpandLess: ExpandLess,
  ExpandMore: ExpandMore,
  ExpandMoreOutline: ExpandMoreOutline,
  Facebook: Facebook,
  Farba60: Farba60,
  Filter: Filter,
  FilterList: FilterList,
  FilterUnselected: FilterUnselected,
  Filters: Filters,
  Floor: Floor,
  FreeInteriorDesign: FreeInteriorDesign,
  Friendly: Friendly,
  FullInterior: FullInterior,
  Furniture: Furniture,
  GlebokaStruktura60: GlebokaStruktura60,
  Grid: Grid,
  GridSelected: GridSelected,
  GridSelected2: GridSelected2,
  GroupMonitor: GroupMonitor,
  GruboscBezPodkladu5Mm60: GruboscBezPodkladu5Mm60,
  GruboscZpodkladem515Mm60: GruboscZpodkladem515Mm60,
  Guarantee10Years: Guarantee10Years,
  Guarantee2Years: Guarantee2Years,
  Help: Help,
  HelpOutline: HelpOutline,
  Hettich: Hettich,
  InPost: InPost,
  Info: Info,
  InfoOutline: InfoOutline,
  InsertDriveFile: InsertDriveFile,
  InsertDriveFilePlus: InsertDriveFilePlus,
  InsertPhoto: InsertPhoto,
  Instagram: Instagram,
  Interiors: Interiors,
  IzolacjaAkustyczna60: IzolacjaAkustyczna60,
  KlasaUzytkowa60: KlasaUzytkowa60,
  KomfortChodzenia60: KomfortChodzenia60,
  KonstrukcjaPlytowa60: KonstrukcjaPlytowa60,
  KonstrukcjaRamiakowa60: KonstrukcjaRamiakowa60,
  KontaktZzywnoscia60: KontaktZzywnoscia60,
  Kronospan: Kronospan,
  Language: Language,
  LatweUtrzymanieCzystosci60: LatweUtrzymanieCzystosci60,
  LatwyMontaz60: LatwyMontaz60,
  Lekkosc60: Lekkosc60,
  Link: Link,
  Linkedin: Linkedin,
  List: List,
  ListSelected: ListSelected,
  LocationSearching: LocationSearching,
  Logged: Logged,
  Login: Login,
  Login1: Login1,
  LoginOutline: LoginOutline,
  Logo: Logo,
  LogoVoxBlack: LogoVoxBlack,
  Loudspeaker: Loudspeaker,
  Mail6015: Mail6015,
  Maps: Maps,
  MaterialLibrary: MaterialLibrary,
  MatowaPowierzchnia60: MatowaPowierzchnia60,
  Meet6010: Meet6010,
  Meet6015: Meet6015,
  MeetOutline: MeetOutline,
  Menu: Menu,
  Minus: Minus,
  Minus2: Minus2,
  Minus3: Minus3,
  Money: Money,
  MoneyNarrow: MoneyNarrow,
  MontazNaKlej60: MontazNaKlej60,
  MontazPionPoziom60: MontazPionPoziom60,
  MontazScianaSufit60: MontazScianaSufit60,
  MoreHoriz: MoreHoriz,
  MoreVert: MoreVert,
  NaNierownePodloza60: NaNierownePodloza60,
  Navigation: Navigation,
  NavigationBack: NavigationBack,
  NieWymagaKonserwacji60: NieWymagaKonserwacji60,
  NoAssembly: NoAssembly,
  OdpornaNaUderzenia60: OdpornaNaUderzenia60,
  OdpornaNaZmianyTemperatury60: OdpornaNaZmianyTemperatury60,
  OdpornoscNaUderzenia60: OdpornoscNaUderzenia60,
  OdpornoscNaZadrapania60: OdpornoscNaZadrapania60,
  OdpornoscUv60: OdpornoscUv60,
  OgrzewaniePodlogowe60: OgrzewaniePodlogowe60,
  Okleina60: Okleina60,
  OrderArrowList: OrderArrowList,
  Paragon: Paragon,
  PaymentLink: PaymentLink,
  Percent: Percent,
  PhoneCheck: PhoneCheck,
  Pinterest: Pinterest,
  PioroWpust60: PioroWpust60,
  Place1: Place1,
  Place2: Place2,
  Place6015: Place6015,
  PlaceOutline: PlaceOutline,
  PlaceOutline2: PlaceOutline2,
  Plamoodporna60: Plamoodporna60,
  PlasterMiodu60: PlasterMiodu60,
  PlytaOtworowana60: PlytaOtworowana60,
  PlytaPelna60: PlytaPelna60,
  Poland6010: Poland6010,
  PolandOutlined: PolandOutlined,
  Print: Print,
  Przylgowe60: Przylgowe60,
  Recykling60: Recykling60,
  ReportGmailerrorred: ReportGmailerrorred,
  Resize: Resize,
  Revers60: Revers60,
  Rotate: Rotate,
  RysunekDrewna60: RysunekDrewna60,
  Safe: Safe,
  Search: Search,
  Send: Send,
  Send2: Send2,
  Settings: Settings,
  Shield: Shield,
  Shit: Shit,
  ShoppingCart: ShoppingCart,
  SoppingCart0: SoppingCart0,
  SpeakerOff: SpeakerOff,
  SpeakerOn: SpeakerOn,
  Spinner: Spinner,
  Star: Star,
  StrongClick60: StrongClick60,
  StrukturaKamien60: StrukturaKamien60,
  SubtelneLaczenie60: SubtelneLaczenie60,
  Succes: Succes,
  Surface: Surface,
  SwapVert: SwapVert,
  SystemClick60: SystemClick60,
  Szyba60: Szyba60,
  SzybkiMontaz60: SzybkiMontaz60,
  Testmagda: Testmagda,
  Trash: Trash,
  Truck: Truck,
  TruckNarrow: TruckNarrow,
  UkrytaOscieznica60: UkrytaOscieznica60,
  UkrytaWentylacja60: UkrytaWentylacja60,
  Upload: Upload,
  Users: Users,
  Verified: Verified,
  Vfuga60: Vfuga60,
  Visibility: Visibility,
  VisibilityOff: VisibilityOff,
  VoxGate: VoxGate,
  Voxbox: Voxbox,
  Voxbox6010: Voxbox6010,
  Voxbox6015: Voxbox6015,
  VoxboxMonitor: VoxboxMonitor,
  VoxboxNarrow: VoxboxNarrow,
  VoxboxOutline: VoxboxOutline,
  WalkingComfort: WalkingComfort,
  WalkingComfortRounded: WalkingComfortRounded,
  Walls: Walls,
  Warning: Warning,
  WarningAmber: WarningAmber,
  WatchLater: WatchLater,
  WatchOutlined: WatchOutlined,
  WentylacjaFasady60: WentylacjaFasady60,
  Whatsapp: Whatsapp,
  Wodoodporna60: Wodoodporna60,
  Wodoodpornosc60: Wodoodpornosc60,
  Youtube: Youtube,
  ZintegrowanyPodklad60: ZintegrowanyPodklad60,
  FullInteriorXl: FullInteriorXl,
  Guarantee: Guarantee,
  Offer: Offer,
  StainResistant: StainResistant,
  Waterproof: Waterproof
};
export type TIcon = "Add" | "Add2" | "Add3" | "Advance" | "Advisor" | "AdvisorOutlined" | "Antyposlizgowa60" | "ArchitectZone" | "ArchitectsZone" | "ArrowBack" | "ArrowBackBold" | "ArrowBackSmall" | "ArrowDown" | "ArrowForward" | "ArrowRight" | "ArrowTopLong" | "ArrowUp" | "Assembly" | "AssemblyNarrow" | "Assignment" | "Bag" | "Bezprzylgowe60" | "BigArrowRight" | "BigChevronLeft" | "BigChevronRight" | "Blank" | "Bringing" | "BringingOff" | "Call" | "Card" | "Catalogue6015" | "Chat" | "Chat2" | "Check" | "Check2" | "CheckCircle" | "CheckCircleOutline" | "Checklist6015" | "ChevronLeft" | "ChevronRight" | "CichaPodloga60" | "Clean" | "Close" | "Close2" | "Close3" | "CoffeOutline" | "Coffee" | "Coffee6015" | "Copy" | "Create" | "Creative" | "Cubic" | "CubicMonitor" | "Customize" | "CustomizeRounded" | "Date" | "Delivery6010" | "Delivery6015" | "DeliveryOutline" | "DesignInVoxboxVr" | "Divide" | "Door" | "Door6010" | "Doors" | "Download" | "Download2" | "DragHandle" | "EcCart" | "EcCart2" | "Eclipse" | "Egger" | "Email" | "EmptyPicture" | "Error" | "ErrorOutline" | "ExpandLess" | "ExpandMore" | "ExpandMoreOutline" | "Facebook" | "Farba60" | "Filter" | "FilterList" | "FilterUnselected" | "Filters" | "Floor" | "FreeInteriorDesign" | "Friendly" | "FullInterior" | "Furniture" | "GlebokaStruktura60" | "Grid" | "GridSelected" | "GridSelected2" | "GroupMonitor" | "GruboscBezPodkladu5Mm60" | "GruboscZpodkladem515Mm60" | "Guarantee10Years" | "Guarantee2Years" | "Help" | "HelpOutline" | "Hettich" | "InPost" | "Info" | "InfoOutline" | "InsertDriveFile" | "InsertDriveFilePlus" | "InsertPhoto" | "Instagram" | "Interiors" | "IzolacjaAkustyczna60" | "KlasaUzytkowa60" | "KomfortChodzenia60" | "KonstrukcjaPlytowa60" | "KonstrukcjaRamiakowa60" | "KontaktZzywnoscia60" | "Kronospan" | "Language" | "LatweUtrzymanieCzystosci60" | "LatwyMontaz60" | "Lekkosc60" | "Link" | "Linkedin" | "List" | "ListSelected" | "LocationSearching" | "Logged" | "Login" | "Login1" | "LoginOutline" | "Logo" | "LogoVoxBlack" | "Loudspeaker" | "Mail6015" | "Maps" | "MaterialLibrary" | "MatowaPowierzchnia60" | "Meet6010" | "Meet6015" | "MeetOutline" | "Menu" | "Minus" | "Minus2" | "Minus3" | "Money" | "MoneyNarrow" | "MontazNaKlej60" | "MontazPionPoziom60" | "MontazScianaSufit60" | "MoreHoriz" | "MoreVert" | "NaNierownePodloza60" | "Navigation" | "NavigationBack" | "NieWymagaKonserwacji60" | "NoAssembly" | "OdpornaNaUderzenia60" | "OdpornaNaZmianyTemperatury60" | "OdpornoscNaUderzenia60" | "OdpornoscNaZadrapania60" | "OdpornoscUv60" | "OgrzewaniePodlogowe60" | "Okleina60" | "OrderArrowList" | "Paragon" | "PaymentLink" | "Percent" | "PhoneCheck" | "Pinterest" | "PioroWpust60" | "Place1" | "Place2" | "Place6015" | "PlaceOutline" | "PlaceOutline2" | "Plamoodporna60" | "PlasterMiodu60" | "PlytaOtworowana60" | "PlytaPelna60" | "Poland6010" | "PolandOutlined" | "Print" | "Przylgowe60" | "Recykling60" | "ReportGmailerrorred" | "Resize" | "Revers60" | "Rotate" | "RysunekDrewna60" | "Safe" | "Search" | "Send" | "Send2" | "Settings" | "Shield" | "Shit" | "ShoppingCart" | "SoppingCart0" | "SpeakerOff" | "SpeakerOn" | "Spinner" | "Star" | "StrongClick60" | "StrukturaKamien60" | "SubtelneLaczenie60" | "Succes" | "Surface" | "SwapVert" | "SystemClick60" | "Szyba60" | "SzybkiMontaz60" | "Testmagda" | "Trash" | "Truck" | "TruckNarrow" | "UkrytaOscieznica60" | "UkrytaWentylacja60" | "Upload" | "Users" | "Verified" | "Vfuga60" | "Visibility" | "VisibilityOff" | "VoxGate" | "Voxbox" | "Voxbox6010" | "Voxbox6015" | "VoxboxMonitor" | "VoxboxNarrow" | "VoxboxOutline" | "WalkingComfort" | "WalkingComfortRounded" | "Walls" | "Warning" | "WarningAmber" | "WatchLater" | "WatchOutlined" | "WentylacjaFasady60" | "Whatsapp" | "Wodoodporna60" | "Wodoodpornosc60" | "Youtube" | "ZintegrowanyPodklad60" | "FullInteriorXl" | "Guarantee" | "Offer" | "StainResistant" | "Waterproof";
export const IconList = ["Add", "Add2", "Add3", "Advance", "Advisor", "AdvisorOutlined", "Antyposlizgowa60", "ArchitectZone", "ArchitectsZone", "ArrowBack", "ArrowBackBold", "ArrowBackSmall", "ArrowDown", "ArrowForward", "ArrowRight", "ArrowTopLong", "ArrowUp", "Assembly", "AssemblyNarrow", "Assignment", "Bag", "Bezprzylgowe60", "BigArrowRight", "BigChevronLeft", "BigChevronRight", "Blank", "Bringing", "BringingOff", "Call", "Card", "Catalogue6015", "Chat", "Chat2", "Check", "Check2", "CheckCircle", "CheckCircleOutline", "Checklist6015", "ChevronLeft", "ChevronRight", "CichaPodloga60", "Clean", "Close", "Close2", "Close3", "CoffeOutline", "Coffee", "Coffee6015", "Copy", "Create", "Creative", "Cubic", "CubicMonitor", "Customize", "CustomizeRounded", "Date", "Delivery6010", "Delivery6015", "DeliveryOutline", "DesignInVoxboxVr", "Divide", "Door", "Door6010", "Doors", "Download", "Download2", "DragHandle", "EcCart", "EcCart2", "Eclipse", "Egger", "Email", "EmptyPicture", "Error", "ErrorOutline", "ExpandLess", "ExpandMore", "ExpandMoreOutline", "Facebook", "Farba60", "Filter", "FilterList", "FilterUnselected", "Filters", "Floor", "FreeInteriorDesign", "Friendly", "FullInterior", "Furniture", "GlebokaStruktura60", "Grid", "GridSelected", "GridSelected2", "GroupMonitor", "GruboscBezPodkladu5Mm60", "GruboscZpodkladem515Mm60", "Guarantee10Years", "Guarantee2Years", "Help", "HelpOutline", "Hettich", "InPost", "Info", "InfoOutline", "InsertDriveFile", "InsertDriveFilePlus", "InsertPhoto", "Instagram", "Interiors", "IzolacjaAkustyczna60", "KlasaUzytkowa60", "KomfortChodzenia60", "KonstrukcjaPlytowa60", "KonstrukcjaRamiakowa60", "KontaktZzywnoscia60", "Kronospan", "Language", "LatweUtrzymanieCzystosci60", "LatwyMontaz60", "Lekkosc60", "Link", "Linkedin", "List", "ListSelected", "LocationSearching", "Logged", "Login", "Login1", "LoginOutline", "Logo", "LogoVoxBlack", "Loudspeaker", "Mail6015", "Maps", "MaterialLibrary", "MatowaPowierzchnia60", "Meet6010", "Meet6015", "MeetOutline", "Menu", "Minus", "Minus2", "Minus3", "Money", "MoneyNarrow", "MontazNaKlej60", "MontazPionPoziom60", "MontazScianaSufit60", "MoreHoriz", "MoreVert", "NaNierownePodloza60", "Navigation", "NavigationBack", "NieWymagaKonserwacji60", "NoAssembly", "OdpornaNaUderzenia60", "OdpornaNaZmianyTemperatury60", "OdpornoscNaUderzenia60", "OdpornoscNaZadrapania60", "OdpornoscUv60", "OgrzewaniePodlogowe60", "Okleina60", "OrderArrowList", "Paragon", "PaymentLink", "Percent", "PhoneCheck", "Pinterest", "PioroWpust60", "Place1", "Place2", "Place6015", "PlaceOutline", "PlaceOutline2", "Plamoodporna60", "PlasterMiodu60", "PlytaOtworowana60", "PlytaPelna60", "Poland6010", "PolandOutlined", "Print", "Przylgowe60", "Recykling60", "ReportGmailerrorred", "Resize", "Revers60", "Rotate", "RysunekDrewna60", "Safe", "Search", "Send", "Send2", "Settings", "Shield", "Shit", "ShoppingCart", "SoppingCart0", "SpeakerOff", "SpeakerOn", "Spinner", "Star", "StrongClick60", "StrukturaKamien60", "SubtelneLaczenie60", "Succes", "Surface", "SwapVert", "SystemClick60", "Szyba60", "SzybkiMontaz60", "Testmagda", "Trash", "Truck", "TruckNarrow", "UkrytaOscieznica60", "UkrytaWentylacja60", "Upload", "Users", "Verified", "Vfuga60", "Visibility", "VisibilityOff", "VoxGate", "Voxbox", "Voxbox6010", "Voxbox6015", "VoxboxMonitor", "VoxboxNarrow", "VoxboxOutline", "WalkingComfort", "WalkingComfortRounded", "Walls", "Warning", "WarningAmber", "WatchLater", "WatchOutlined", "WentylacjaFasady60", "Whatsapp", "Wodoodporna60", "Wodoodpornosc60", "Youtube", "ZintegrowanyPodklad60", "FullInteriorXl", "Guarantee", "Offer", "StainResistant", "Waterproof"];